<div class="tooth" #toothElement [class.show-hover]="showHoverEffect">
  @if (showRoot) {
    <div
      class="tooth__root"
      [class.readonly]="readonly"
      [ngStyle]="{ 'height.px': toothHeight }"
      [ngClass]="[
        tooth.root.orderProduct?.id ? toothStatus.disabled : toothStatus.empty,
        !tooth.root.orderProduct?.id && tooth.root.orderProduct?.is_configured
          ? toothStatus.approved
          : toothStatus.empty,
        selectedTooth?.tooth?.number === tooth.number && selectedTooth?.toothPart === toothPart.root
          ? 'edit-' + toothStatus.clicked
          : toothStatus.empty,
      ]"
      (click)="handleToothPartClick(toothPart.root)">
      @if (tooth.root.orderProduct?.product && (iconPath?.root | assetExists | async)) {
        <img [src]="iconPath?.root" alt="" />
      }
      @if (!readonly) {
        <ng-content select="app-rotary-dial"></ng-content>
      }
    </div>
  }

  <div
    class="tooth__crown"
    [class.readonly]="readonly"
    [ngStyle]="{ 'height.px': toothHeight }"
    [class.linked]="tooth?.has_link"
    [class.green]="tooth?.is_configured"
    [class.blue]="isPartOfZone || tooth?.crown?.orderProducts?.length || active"
    [class.edit-blue]="active"
    (click)="handleToothPartClick(toothPart?.crown)">
    <app-tooth-icon [isSelected]="active" [tooth]="tooth"> </app-tooth-icon>

    @if (tooth?.crown?.orderProducts?.length > 1) {
      <span
        [class.tooth-count-revert]="active"
        [ngClass]="['tooth-count', active ? 'tooth-count-revert' : toothStatus.empty]">
        {{ tooth?.crown?.orderProducts?.length }}
      </span>
    }

    @if (!readonly) {
      <ng-content select="app-crown-actions"></ng-content>
    }
  </div>

  <ng-content select="app-tooth-connection"></ng-content>

  <div class="tooth__number" [ngStyle]="{ 'height.px': toothHeight }">
    <span>{{ tooth?.number }}</span>
  </div>
</div>
